/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetMetadata200ResponseData } from './GetMetadata200ResponseData'
import {
  GetMetadata200ResponseDataFromJSON,
  GetMetadata200ResponseDataFromJSONTyped,
  GetMetadata200ResponseDataToJSON,
} from './GetMetadata200ResponseData'

/**
 *
 * @export
 * @interface GetMetadata200Response
 */
export interface GetMetadata200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetMetadata200Response
   */
  status: boolean
  /**
   *
   * @type {GetMetadata200ResponseData}
   * @memberof GetMetadata200Response
   */
  data: GetMetadata200ResponseData
}

/**
 * Check if a given object implements the GetMetadata200Response interface.
 */
export function instanceOfGetMetadata200Response(
  value: object
): value is GetMetadata200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetMetadata200ResponseFromJSON(
  json: any
): GetMetadata200Response {
  return GetMetadata200ResponseFromJSONTyped(json, false)
}

export function GetMetadata200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetMetadata200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetMetadata200ResponseDataFromJSON(json['data']),
  }
}

export function GetMetadata200ResponseToJSON(
  value?: GetMetadata200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetMetadata200ResponseDataToJSON(value['data']),
  }
}
